import { Fieldset } from 'primereact/fieldset';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import useUtilAdmin from './useUtilAdmin';

const Utiladmin = () => {
    const {
        toast,
        cargaUsu,
        usuarios,
        setUsuarios,
        cargaProyecto,
        proyecto,
        setProyecto,
        cargaPuesto,
        multiPuesto,
        setMultiPuesto,
        handleClick,
        procesaReg,
        datosUsuPue,
        datosUPSelect,
        setDatosUPSelect,
        cargaDatUsuPue,
        lstUsuarios,
        lstProyecto,
        lstPuesto,
        handleElimina,
        procesaBorra,
        filtros,
        textoFilterTemplate
    } = useUtilAdmin();

    return (
        <div className="card">
            <Toast ref={toast} />
            <Fieldset legend="Asignacion de Puestos">
                <div className="formgrid grid p-fluid mb-3">
                    <div className="field col-12 md:col-4">
                        {/* Usuario */}
                        <label>Usuario:</label>
                        {cargaUsu ? (
                            <div className="flex align-items-center">
                                <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                            </div>
                        ) : (
                            <MultiSelect value={usuarios} onChange={(evt) => setUsuarios(evt.value)} options={lstUsuarios} optionLabel="usuarioNombre" placeholder="Seleccione Usuario" filter={true} maxSelectedLabels={3} />
                        )}
                    </div>
                    {/*Proyecto */}
                    <div className="field col-12 md:col-4">
                        <label htmlFor="cboProyecto">Proyecto:</label>
                        {cargaProyecto ? (
                            <div className="flex align-items-center">
                                <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                            </div>
                        ) : (
                            <Dropdown inputId="cboProyecto" value={proyecto} onChange={(evt) => setProyecto(evt.value)} options={lstProyecto} optionLabel="descripcion" placeholder="Elija un Proyecto" filter showClear />
                        )}
                    </div>
                    {/* Puesto */}
                    <div className="field col-12 md:col-4">
                        <label htmlFor="cboPuesto">Puesto:</label>
                        {cargaPuesto ? (
                            <div className="flex align-items-center">
                                <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                            </div>
                        ) : (
                            <MultiSelect value={multiPuesto} onChange={(evt) => setMultiPuesto(evt.value)} options={lstPuesto} optionLabel="descripcion" filter={true} maxSelectedLabels={3} />
                        )}
                    </div>
                    <div className="field col-12 md:col-4">
                        <span></span>
                    </div>
                    <div className="field col-12 md:col-4">
                        <span></span>
                    </div>
                    <div className="field col-12 md:col-4">
                        <Button label="Registrar" onClick={handleClick} loading={procesaReg} />
                    </div>
                </div>
            </Fieldset>
            <Fieldset legend="Eliminacion de Puestos">
                <div className="formgrid grid p-fluid mb-3">
                    <div className="field col-12 md:col-11">
                        <DataTable
                            value={datosUsuPue}
                            selectionMode="checkbox"
                            selection={datosUPSelect}
                            onSelectionChange={(e) => setDatosUPSelect(e.value)}
                            dataKey="usuarioPuestoId"
                            paginator
                            rows={4}
                            rowsPerPageOptions={[4, 8, 12, 16]}
                            filters={filtros}
                            filterDisplay="row"
                            emptyMessage="No se encontraron resultados."
                            tableStyle={{ minWidth: '50rem', tableLayout: 'fixed' }}
                            size="small"
                            stripedRows
                            loading={cargaDatUsuPue}
                            scrollable
                        >
                            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} ></Column>
                            <Column header="usuario" field="usuarioName" filter filterPlaceholder="Filtro Usuario" filterElement={(options) => textoFilterTemplate(options, 'usuarioName')} showFilterMenu={false} ></Column>
                            <Column header="Cliente Sigla" field="clienteSigla" filter filterPlaceholder="Filtro Cliente" filterElement={(options) => textoFilterTemplate(options, 'clienteSigla')} showFilterMenu={false}></Column>
                            <Column header="Proyecto Sigla" field="proyectoSigla" filter filterPlaceholder="Buscar por proyecto" filterElement={(options) => textoFilterTemplate(options, 'proyectoSigla')} showFilterMenu={false} style={{ minWidth: '20px', wordBreak: 'break-word', verticalAlign: 'top' }}></Column>
                            <Column header="Proyecto Nombre" field="proyectoNombre" filter filterPlaceholder="Filtro Nombre" filterElement={(options) => textoFilterTemplate(options, 'proyectoNombre')} showFilterMenu={false}></Column>
                            <Column header="Puesto Sigla" field="puestoSigla" filter filterPlaceholder="Buscar por puesto" filterElement={(options) => textoFilterTemplate(options, 'puestoSigla')} showFilterMenu={false} style={{ minWidth: '200px', wordBreak: 'break-word', verticalAlign: 'top' }} ></Column>
                            <Column header="Puesto Nombre" field="puestoNombre" filter filterPlaceholder="Filtro Nombre" filterElement={(options) => textoFilterTemplate(options, 'puestoNombre')} showFilterMenu={false}></Column>
                        </DataTable>
                    </div>
                    <div className="field col-12 md:col-1">
                        <Button
                            label={
                                <>
                                    Eliminar
                                    <br />
                                    Marcados
                                </>
                            }
                            className="p-button-danger"
                            onClick={handleElimina}
                            loading={procesaBorra}
                        />
                    </div>
                </div>
            </Fieldset>
        </div>
    );
};

export default Utiladmin;
